var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.finishedLoading)?_c('div',{staticClass:"app"},[(_vm.authenticated)?_c('secured-app'):_c('insecure-app'),_c('hlt-notifications'),_c('vue-confirm-dialog')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }